app.service('productDetailDynamicSuite', function (productCardConfig, modal, lazyLoad, price, cartManager, viewPoint, store, log) {

	let config;
	let modals = {}, selectedPackages = [];
	let $tabSection, $tab, $packages, $oldPrice, $currentPrice, $saving, $headerSublabel;
	let groupName, initiallySelectedProducts = [];

	function init() {
		$tabSection = $("[data-section-id=zestaw]");
		$tab = $('#dynamic-suite');

		if (!$tab.length) return;
		config = $.extend({}, productCardConfig.getData());

		setEvents();
		loadDynamicSuite();
	}

	function setEvents() {

		groupName = config.groupName.split(" ").join("_");

		$tab
			.on('click', '.js-add-dynamic-suite', handleAddDynamicSuiteToCartClick)
			.on('click', '.js-select-product', handleSelectProductClick)
			.on('click', '.js-select-package', handleSelectPackageClick)
			.on('click', '.product-photo', function () {
				UA.interaction('KP_Zestawy', 'Klikniecia', `${groupName}_Zdjecie`);
			})
			.on('click', '.package-product-photo a', function (e) {
				e.preventDefault();
				UA.interaction('KP_Zestawy', 'Klikniecia', `${groupName}_Zdjecie`);
				window.location.href = this.href;
			});

		$('body').on('click', '.js-select-package-product', handleSelectPackageProductClick);

		store.onChange(loadDynamicSuite);
	}

	function handleAddDynamicSuiteToCartClick() {
		let productId = $(this).data('product-id');
		let packageProductsIds = $packages.filter('.is-selected')
			.find('.package-product-item.is-selected')
			.map((i, el) => $(el).data('package-product-id'))
			.toArray();
		cartManager.addDynamicSuite(productId, packageProductsIds);

		log.recommendationsForAWS({
			productPlu: config.plu,
			eventCategory: 'KP',
			eventAction: 'Dodanie do koszyka'
		});

		if (hasAnyProductInSuiteBeenChanged(packageProductsIds)) {
			UA.interaction('KP_Zestawy', 'Dodanie_do_koszyka', `${groupName}_Zmieniony`);
		} else {
			UA.interaction('KP_Zestawy', 'Dodanie_do_koszyka', `${groupName}_Domyslny`);
		}
	}

	function hasAnyProductInSuiteBeenChanged(packageProductsIds) {

		let hasAnyProductChanged = false;

		packageProductsIds.forEach(id => {
			if (initiallySelectedProducts.indexOf(id) === -1) {
				hasAnyProductChanged = true;
			}
		});

		return hasAnyProductChanged;
	}

	function handleSelectProductClick() {
		const packageIndex = $(this).data('package-index');
		const selectedProduct = $packages.eq(packageIndex)
			.find('.package-product-item.is-selected')
			.index();

		modals[packageIndex] = modal.open(`package-products-${packageIndex}`);

		modals[packageIndex].$modal
			.find('.package-products-modal > div')
			.eq(selectedProduct)
			.find('.js-select-package-product')
			.prop('checked', true);

		modals[packageIndex].$modal
			.find('.package-product-item')
			.each((i, el) => el.className = 'package-product-item')
			.addClass(`discount-level-${selectedPackages.length}`);

		UA.interaction('KP_Zestawy', 'Wybierz_inny_produkt', groupName);
	}

	function handleSelectPackageProductClick() {
		const packageIndex = +this.value;
		const productIndex = $(this).closest('div').index();

		$packages
			.eq(packageIndex)
			.find('.package-product-item')
			.removeClass('is-selected')
			.eq(productIndex)
			.addClass('is-selected');

		modals[packageIndex].$modal.find('.js-select-package-product')
			.not($(this))
			.prop('checked', false);

		modals[packageIndex].close();

		lazyLoad.update();

		recalculateAll();
	}

	function handleSelectPackageClick() {
		saveSelected.call(this);
		recalculateAll();
	}

	function recalculateAll() {
		updateDiscounts();
		calculateTotal();
		setHeaderSublabel();
	}

	function setElements() {
		$packages = $tab.find('.dynamic-suite-package');
		$oldPrice = $tab.find('.dynamic-suite-old-price');
		$currentPrice = $tab.find('.dynamic-suite-price .price-normal');
		$saving = $tab.find('.dynamic-suite-saving span');
		$headerSublabel = $('.product-tab-header').find('.header-sublabel');

		if ($headerSublabel.length <= 0) {
			$headerSublabel = $('<div class="header-sublabel"/>');
			$tab.prev('.product-tab-header').append($headerSublabel);
		}
	}

	function loadDynamicSuite() {
		selectedPackages = [];
		Object.keys(modals).forEach(index => modals[index].destroy());

		if (store.data.isOutlet) {
			$tabSection.addClass('is-hidden');
			return;
		}

		$tabSection.removeClass('is-hidden');
		setElements();
		selectFirstProduct();
		selectAllPackages();
		recalculateAll();
	}

	function selectFirstProduct() {
		let $items = $packages.find('.package-product-item:first-child').addClass('is-selected');
		$items.each(function() {
			let productId = $(this).data('package-product-id');
			initiallySelectedProducts.push(productId);
		});
	}

	function selectAllPackages() {
		if (!$packages.find('.js-select-package:checked').length) {
			$packages.find('.js-select-package').prop('checked', true);
		} 
		$packages.find('.js-select-package').each(saveSelected);
		recalculateAll();
	}

	function saveSelected() {
		const checked = this.checked;
		const index = $(this).closest('.dynamic-suite-package').index();

		if (checked) {
			selectedPackages = selectedPackages.indexOf(index) === -1 ? selectedPackages.concat(index) : selectedPackages;
		} else {
			selectedPackages = selectedPackages.filter(i => i !== index);
		}
	}

	function updateDiscounts() {
		$packages.each((i, el) => el.className = 'dynamic-suite-package');

		if (!selectedPackages.length) return;

		selectedPackages.forEach(index => {
			$packages.eq(index).addClass('is-selected');
		});

		$packages.addClass(`discount-level-${selectedPackages.length}`);
	}

	function calculateTotal() {

		$tab.toggleClass('no-accessories', !selectedPackages.length);

		if (!selectedPackages.length) return;

		const mainProductPrice =  +$tab.find('.suite-main-product .product-price').data('price');
		
		const productPrices = $packages
			.filter('.is-selected')
			.map(function () {
				const discountedPrice = +$(this).find('.price-discount').data('price');
				const oldPrice = +$(this).find('.price-old').data('price');

				return {
					discountedPrice,
					oldPrice
				};
			})
			.get();

		const currentPrice = price.add(mainProductPrice, productPrices.reduce((acc, next) => acc + next.discountedPrice, 0));
		const oldPrice = price.add(mainProductPrice, productPrices.reduce((acc, next) => acc + next.oldPrice, 0));
		const saving = price.subtract(oldPrice, currentPrice);
		renderTotal(currentPrice, oldPrice, saving);
	}

	function currentDiscountPercentage() {
		return $packages
			.filter('.is-selected')
			.first()
			.map((i, el) => $(el)
				.find('.discount-percentage')
				.data('percentage'))[0];
	}

	function setHeaderSublabel() {
		if (!selectedPackages.length) {
			$headerSublabel.empty();
			return;
		}
		const itemCount = selectedPackages.length;
		const percent = currentDiscountPercentage();
		const itemText = `${itemCount} ` + (itemCount > 1 ? 'akcesoriami' : 'akcesorium');
		const lastText = itemCount > 1 ? 'akcesoria' : 'akcesorium';
		$headerSublabel.html(`Kup ten towar z ${itemText} i zyskaj <span class="header-sublabel-percent"> ${percent}% rabatu na wybrane ${lastText}!</span>`);
	}

	function renderTotal(currentPrice, oldPrice, saving) {
		$oldPrice.text(price.format(oldPrice));
		$currentPrice.text(price.format(currentPrice));
		$saving.text(price.format(saving));
	}

	return {
		init
	};
});
